<template>
  <div
    name="rb-checkbox"
    :style="cssVars"
    @click="$emit('update:modelValue', !props.modelValue)"
  >
    <input
      type="checkbox"
      :name="props.name"
      :checked="props.modelValue"
      :required="props.required"
      :class="{ primary, secondary }"
    >
    <label :for="props.name">
      <slot>
        {{ props.label }}
      </slot>
    </label>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
defineEmits(['update:modelValue']);
const props = withDefaults(defineProps<{
  modelValue: boolean,
  name: string,
  label?: string,
  color?: string,
  primary?: boolean,
  secondary?: boolean,
  required?: boolean,
}>(), {
  color: undefined,
  modelValue: false,
  label: '',
  required: false
});

const cssVars = computed(() => {
  return {
    ['--color']: props.color
  };
});

</script>

<style lang="scss" scoped>
div[name="rb-checkbox"] {
  * {
    cursor: pointer;
  }

  width: fit-content;
  display: flex;
  align-items: center;
  gap: 8px;

  &>input {
    height: 20px;
    aspect-ratio: 1/1;
    accent-color: var(--color);
    margin: 0;

    &.primary {
      accent-color: var(--primary);
    }

    &.secondary {
      accent-color: var(--secondary);
    }
  }

  &>label {
    text-wrap: wrap;
    word-wrap: break-word;
    vertical-align: middle;
    font-size: 0.875rem;
    line-height: 1.1rem;
    color: rgba(77, 77, 77, 1);
  }
}
</style>
